import BaseCommand from "@/models/api/commands/BaseCommand";

export class CopyAmountToAllBookingItem extends BaseCommand {
  Command: {
    AmountInCurrency: number;
    Currency: string;
    Amount: number;
    ExchangeDate: string | null;
    ExchangeRate: number | null;
  };
  constructor(
    sessionId: string,
    operationId: string,
    amountInCurrency: number,
    currency: string,
    amount: number,
    exchangeDate: string | null,
    exchangeRate: number | null
  ) {
    super(sessionId, operationId);
    this.Command = {
      AmountInCurrency: amountInCurrency,
      Currency: currency,
      Amount: amount,
      ExchangeDate: exchangeDate,
      ExchangeRate: exchangeRate,
    };
  }
}
